import { render } from "./SidebarContentLayout.vue?vue&type=template&id=4ec01157"
import script from "./SidebarContentLayout.vue?vue&type=script&lang=js"
export * from "./SidebarContentLayout.vue?vue&type=script&lang=js"

import "./SidebarContentLayout.vue?vue&type=style&index=0&id=4ec01157&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__